import PackageService from "src/services/PackageService";
import ModuleCreator from "src/store/ModuleCreator";

export const types = {};
export const params = {
	lottery_id:"",
	price:"",
	amount:"",
	title:"",
	subtitle:"",
    thanks_words:""

};

/**
@namespace
@property  {object} module,
@property  {object} module.state,
@property  {object} modules.package,
@property  {array}  modules.packages
**/

const module = {
	state: {},
	mutations: {},
	getters: {},
	actions: {},
	types: types
};
export default ModuleCreator("package", PackageService, module, types ,params);
